var map = {
	"./alipay--alipayhk.png": 6534,
	"./alipay--boost.png": 4122,
	"./alipay--fpx.png": 5341,
	"./alipay--grabpayMy.png": 7289,
	"./alipay--grabpaySg.png": 5481,
	"./alipay--paynow.png": 4985,
	"./alipay--touch.png": 7142,
	"./igamebuy--igamebuy.png": 7890,
	"./mycard--mycard.png": 985,
	"./mycard.png": 1907,
	"./tip/alipay--alipayhk.png": 2064,
	"./tip/alipay--boost.png": 6100,
	"./tip/alipay--fpx.png": 4027,
	"./tip/alipay--grabpayMy.png": 887,
	"./tip/alipay--grabpaySg.png": 2119,
	"./tip/alipay--paynow.png": 6467,
	"./tip/alipay--touch.png": 6872,
	"./tip/igamebuy--igamebuy.png": 315,
	"./tip/mycard.png": 7278
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3664;